<template>
  <section
    class="pdf-content"
    style="margin: 10px 20px 15px 0px"
    v-if="memberIdentity"
  >
    <v-row no-gutters>
      <v-col cols="7">
        <img
          style="margin-top: 10px"
          class="text-left"
          :src="logoBase64"
          width="140"
        />
      </v-col>
      <v-col cols="5" class="pa-2 ma-2">
        <div class="plan-header-text text-left">{{ planName }}</div>
        <div v-if="!matchAddress()" class="text-left address-text">
          <pre>{{ eobData && eobData.EOBPlanAddress }}</pre>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="7">
        <div class="date-text bold text-left">
          {{ formatMember(memberIdentity) }}
        </div>
        <div class="data-text text-left">
          <pre>{{ memberAddress(memberIdentity) }}</pre>
        </div>
      </v-col>
      <v-col cols="5" class="pa-2 ma-2">
        <div v-if="provider && provider.FirstName !== 'Unknown' && provider.FirstName !== 'Test' && provider.FirstName !== 'TEST'" class="text-left data-text my-5">
          <span class="bold">{{ `${formatProviderTitle(provider)}: `}}</span><span>{{ `${formatProvider(provider).line1}` }}</span>
          <br />
          <span>{{ `${formatProvider(provider).line2}` }}</span>
        </div>
        <v-row>
          <v-col class="pa-5"></v-col>
        </v-row>
        <div class="data-text text-left">
          <span class="bold">{{ $t("components.claims.print.reference_number") }}:</span>
          {{ claim.Identifier }}
        </div>
        <div v-if="claim.PaymentNumber" class="data-text text-left">
          <span class="bold">{{ $t("views.planbalance.cheque_number") }}:</span>
          {{ claim.PaymentNumber }}
        </div>
        <div v-if="claim.PaymentDate" class="data-text text-left">
          <span class="bold">{{ $t("headers.selfpayments.payment_date") }}:</span>
          {{ claim.PaymentDate.split("T")[0] }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-5"></v-col>
    </v-row>
    <v-container>
      <v-row no-gutters>
        <v-col class="main-header-text text-left">
          {{ $t("components.claims.print.eob.title") }}
        </v-col>
        <v-col class="pa-2 ma-2 text-right">
          {{ $t("components.claims.print.non_negotiable") }}
        </v-col>
      </v-row>
      <div v-for="patient in Object.keys(patients)" :key="patient" class="eob-parent">
        <hr />
        <v-row no-gutters>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims.print.name_of_member") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims.print.predetermination.patient_name") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims.print.certificate") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims.print.group") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("enums.Payment") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("headers.selfpayments.payment_date") }}
            </span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ formatMember(memberIdentity) }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ patient }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ memberIdentity.MemberIdentification.Certificate }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ planNumber }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ $helpers.toCurrency(totalPaidAmountPerPatient(patient)) }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ claim.PaymentDate ? claim.PaymentDate.split("T")[0] : '' }}
            </span>
          </v-col>
        </v-row>
        <hr />
        <v-row>
          <v-col class="pa-40"></v-col>
        </v-row>
        <hr />
        <v-row no-gutters>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims.print.eob.processed_date") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("globals.benefit") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text bold">
              {{ $t("components.claims_history.header.date_of_service") }}
            </span>
          </v-col>
          <v-col
            class="pa-0 ma-0"
            v-if="
              patients[patient].Claims.some(
                (o) =>
                  o.CurrentClaimData.PlanBenefit.Benefit.Coverage === 'Dental'
              )
            "
          >
            <span class="data-text bold">
              {{ $t("components.expenses_table.tooth_code") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("components.claims.print.proposed_charge") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("headers.benefits.cob") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("components.memberview.eligible") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("components.claims.print.co_ins") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("components.claims_history.header.paid") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text bold">
              {{ $t("components.claims.print.messages") }}
            </span>
          </v-col>
        </v-row>
        <hr />
        <v-row
          no-gutters
          v-for="(claimLine, index) in patients[patient].Claims"
          :key="index"
          class="eob-child"
        >
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ claimLine.CurrentClaimData.Timestamp.split("T")[0] }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span
              class="data-text"
              v-if="
              claimLine.CurrentClaimData.PlanBenefit.Benefit.Coverage ===
              'Dental'
            "
            >
              {{ claimLine.CurrentClaimData.PlanBenefit.Benefit.Code }}
            </span>
            <span class="data-text" v-else-if="claimLine.CurrentClaimData.DIN">
              {{ claimLine.CurrentClaimData.DIN }}
            </span>
            <span class="data-text" v-else>
              {{ translate2(claimLine.CurrentClaimData.PlanBenefit.Benefit, "Name") }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0">
            <span class="data-text">
              {{ claimLine.CurrentClaimData.DateOfService.split("T")[0] }}
            </span>
          </v-col>
          <v-col
            class="pa-0 ma-0"
            v-if="
              claimLine.CurrentClaimData.PlanBenefit.Benefit.Coverage ===
              'Dental'
            "
          >
            <span class="data-text">
              {{ claimLine.CurrentClaimData.ToothCode ? claimLine.CurrentClaimData.ToothCode.Code : "" }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{
                $helpers.toCurrency(computeAmount(claimLine))
              }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{ $helpers.toCurrency(claimLine.CurrentClaimData.COBAmount) }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{
                $helpers.toCurrency(computeEligibleAmount(claimLine))
              }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{
                `${claimLine.CurrentClaimData.PlanBenefit.PercentagePayable}%`
              }}
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{ $helpers.toCurrency(computePaidAmount(claimLine)) }}
              <!-- {{ $helpers.toCurrency(claimLine.CurrentClaimData.PaidAmount) }} -->
            </span>
          </v-col>
          <v-col class="pa-0 ma-0 align-right">
            <span class="data-text">
              {{
                [claimLine.CurrentClaimData.AdjudicationError]
                  .concat(claimLine.CurrentClaimData.EOB)
                  .filter(o=>o!==null && o!==undefined)
                  .map((o) => o.code)
                  .join(", ")
              }}
            </span>
          </v-col>
        </v-row>
        <v-container class="eob-child">
          <div v-if="getUniqueCodes().length > 0">
            <v-row>
              <v-col class="messages-title center">
                {{ $t("components.claims.print.messages_title") }}
              </v-col>
            </v-row>
            <v-row v-for="(message, index) in getUniqueCodes()" :key="index">
              <v-col cols="1">
                <span class="data-text">
                  {{ message.code }}
                </span>
              </v-col>
              <v-col>
                <span class="data-text"> -{{ adjudicationMessage(message) }} </span>
              </v-col>
            </v-row>
          </div>
          <div v-if="claim.Notes">
            <v-row>
              <v-col class="messages-title center">
                {{ $t("components.claims.print.comments_title") }}
              </v-col>
            </v-row>
            <template v-for="(note, index) in claim.Notes">
              <v-row :key="index">
                <v-col cols="1">
                  <span class="data-text">
                    {{ note.Writer }}
                  </span>
                </v-col>
                <v-col>
                  <span class="data-text">
                    {{ note.Message }}
                  </span>
                </v-col>
              </v-row>
            </template>
          </div>
        </v-container>
      </div>
    </v-container>
    <v-container class="pt-10 eob-child">
      <v-row
        no-gutters
        justify="space-around"
        v-if="claim.PaymentMethod === 'DirectDeposit'"
      >
        <v-col cols="12">
          <div class="pa-5 ma-5 center box data-text bold">
            {{
              $t("components.claims.print.eob.warning_{0}_{1}", [
                $helpers.toCurrency(totalPaidAmount(patient)),
                getBankName(),
              ])
            }}
          </div>
        </v-col>
      </v-row>
      <v-row justify="start" no-gutters class="eob-child">
        <v-col v-if="eobData.ClaimAdmin">
          <div class="data-text no-wrap">
            <pre
              >{{ $t("components.claims.print.claims_administered_by") }}</pre
            >
            <br />
            <img
              v-if="eobData.ClaimAdmin"
              style="margin-top: 10px"
              class="text-right"
              :src="translate2(eobData.ClaimAdmin, 'LogoBase64')"
              width="140"
            />
            <div class="data-text" v-if="eobData.Underwriter">
              <pre>{{ $t("components.claims.print.underwritten_by") }}</pre>
              <v-img
                style="margin-top: 10px"
                class="text-right"
                :src="translate2(eobData.Underwriter, 'LogoBase64')"
                width="140"
              />
            </div>
            <br />
            <br />
            {{ translate2(eobData.ClaimAdmin, "Name") }}
            <br />
            <div v-html="translate2(eobData.ClaimAdmin, 'Address')"></div>
            <span v-if="translate2(eobData.ClaimAdmin, 'Phone') !== ''">Tel: {{ translate2(eobData.ClaimAdmin, "Phone") }}</span>
            <br />
            <span v-if="translate2(eobData.ClaimAdmin, 'TollFreePhone') !== ''">Toll free : {{ translate2(eobData.ClaimAdmin, "TollFreePhone") }}</span>
            <br />
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col>
          <span v-if="claim.Claims[0].Creator !== ''" class="data-text">
            <pre>{{
              $t("components.claims.print.predetermination.processed_by_{0}", [
                claim.Claims[0].Creator,
              ])
            }}</pre>
          </span>
        </v-col>
      </v-row>
      <!-- <v-row no-gutters justify="start">
          <v-col cols="3">
            <span class="pa-2 ma-2 data-text">
              {{ eobData.EOBPlanAddress }}
            </span>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start">
          <v-col cols="3" class="pa-2 ma-2">
            <span class="pa-2 ma-2 data-text">
              {{ eobData.EOBPlanEmail }}
            </span>
          </v-col>
        </v-row> -->
    </v-container>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { translate2 } from "@/trans2";
import { translate } from "@/trans";
import banks from "./banks.json";
export default {
  props: {
    claim: Object,
    planName: String,
    headers: Array,
    planNumber: String,
  },
  data() {
    return {
      logoForHtml: null,
      provider: undefined,
      memberIdentity: undefined,
      logoBase64: undefined,
      eobData: undefined,
      patients: {},
      hasDirectDeposit: false,
      btnListeners: []
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", ["certificateLabel", "logo", "language"]),
  },
  async mounted() {
    console.log(this.claim);
    const plan = (await this.getPlanLogo(this.claim.PlanId)).data;
    this.logoBase64 = plan.Client.LogoBase64;
    this.eobData = (
      await this.getClaimSettings({
        planIdentityId: this.claim.PlanId,
        brokerId: plan.BrokerId,
      })
    ).data.value[0];
    await this.loadMemberDetails(this.claim.MemberId, this.claim.PlanId);
    this.provider = (
      await this.getProviderById({
        id: this.claim.ProviderId,
      })
    ).data.value[0];
    this.patients = {};
    for (let claimLine of this.claim.Claims) {
      // if (claimLine.State==='Paid' || claimLine.State==='Rejected') {
        const patient = `${claimLine.FirstName} ${claimLine.LastName}`;
        if (Object.keys(this.patients).indexOf(patient) > -1) {
          this.patients[patient].Claims.push(claimLine);
        } else {
          this.patients[patient] = {
            Claims: [claimLine],
          };
        }
      // }
    }
    this.$emit("loaded");
  },
  beforeDestroy() {
    this.btnListeners.forEach(({ btn, listener }) => {
      btn.removeEventListener("load", listener);
    });
  },
  methods: {
    ...mapActions("claims", ["getProviderById", "getClaimSettings"]),
    ...mapActions("plansMembers", ["getMemberInfo", "getPlanLogo"]),
    adjudicationMessage(item) {
      if (item.code === "900" || item.code === "901") {
        return item.message;
      }
      console.log("eob is: ", item, a)
      let a = this.$t(
        `adjudication_message.${item.message}`,
        item.formattedParams
      );
      return a;
    },
    totalPaidAmountPerPatient(patient) {
      let total = 0;
      for (let c of this.patients[patient].Claims) {
        // total += c.CurrentClaimData.PaidAmount;
        total += this.computePaidAmount(c);
      }
      return total;
    },
    totalPaidAmount() {
      let total = 0;
      for (let c of this.claim.Claims) {
        // total += c.CurrentClaimData.PaidAmount;
        total += this.computePaidAmount(c);
      }
      return total;
    },
    computePaidAmount(item) {
      const paidLabFee = parseFloat(item.CurrentClaimData.PaidLabFee);
      if (isNaN(paidLabFee)) {
        return item.CurrentClaimData.PaidAmount;
      }
      return item.CurrentClaimData.PaidAmount + paidLabFee;
    },
    computeAmount(item) {
      const labFee = parseFloat(item.CurrentClaimData.LabFee);
      if (isNaN(labFee)) {
        return item.CurrentClaimData.ExpenseAmount;
      }
      return item.CurrentClaimData.ExpenseAmount + labFee;
    },
    computeEligibleAmount(item) {
      const labFee = parseFloat(item.CurrentClaimData.EligibleLabFee);
      if (isNaN(labFee)) {
        return item.CurrentClaimData.EligibleAmount;
      }
      return item.CurrentClaimData.EligibleAmount + labFee;
    },
    getUniqueCodes() {
      let result = {};
      for (let claimLine of this.claim.Claims) {
        for (let m of claimLine.CurrentClaimData.EOB) {
          if (Object.keys(result).indexOf(m.code) === -1) {
            result[m.code] = m;
          }
        }
        if (claimLine.CurrentClaimData.AdjudicationError) {
          if (Object.keys(result).indexOf(claimLine.CurrentClaimData.AdjudicationError.code) === -1) {
            result[claimLine.CurrentClaimData.AdjudicationError.code] = claimLine.CurrentClaimData.AdjudicationError;
          }
        }
      }
      console.log("####", result)
      return Object.values(result);
    },
    async loadMemberDetails(memberIdentityId, planIdentityId) {
      if (
        memberIdentityId !== null &&
        memberIdentityId !== undefined &&
        memberIdentityId !== "00000000-0000-0000-0000-000000000000"
      ) {
        try {
          this.memberIdentity = (
            await this.getMemberInfo({
              planIdentityId: planIdentityId,
              memberIdentityId: memberIdentityId,
              odataQuery:
                "$select=Id,Email,PlanIdentityId,PlanEntryDate&$expand=CurrentMembershipStatus($expand=MemberGroupIdentity($select=Id;$expand=Current($expand=Translations))),MemberIdentification($select=Certificate),CurrentBankAccount,CurrentMember($select=LastName,FirstName,MiddleName,DateOfBirth),CurrentDependants($select=Id,IdentityId,FirstName,MiddleName,LastName,DateOfBirth;$expand=Relationship($expand=Translations),Identity($select=Code,IsEligible)),CurrentContactInformation($expand=Address($expand=Country($expand=Translations),Province($expand=Translations)))",
            })
          ).data;
          console.log(this.memberIdentity);
        } catch (error) {
          this.error = error;
        }
      } else {
        this.memberIdentity === undefined;
      }
    },
    startDownload() {
      let imageURL = this.logo;
      const listener = this.imageReceived;
      let downloadedImg = new Image();
      downloadedImg.crossOrigin = "Anonymous";
      downloadedImg.addEventListener("load", listener, false);
      downloadedImg.src = imageURL;
      this.btnListeners.push({downloadedImg, listener});
    },

    imageReceived(downloadedImg) {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = downloadedImg.width;
      canvas.height = downloadedImg.height;

      context.drawImage(downloadedImg, 0, 0);

      this.logoForHtml = canvas.toDataURL("image/png");
    },
    translate2(item, field) {
      return translate2(item, field);
    },
    formatProvider(provider) {
      if (provider === undefined) {
        return "";
      }
      console.log(provider);
      return {
        line1: `${provider.FirstName ? provider.FirstName : ''} ${provider.LastName ? provider.LastName : ''}, ${
        provider.UniqueId ? provider.UniqueId : ''}`,
        line2: `${this.providerAddress(provider)}`
      };
    },
    providerAddress(provider) {
      let address = 0;
      let providerOffice = null;
      let office = null;
      if (provider.ProviderOffices && provider.ProviderOffices.length > 0) {
        providerOffice = provider.ProviderOffices.filter(
          (o) => o.OfficeId === this.claim.OfficeId
        );
      }
      if (providerOffice && providerOffice.length > 0) {
        office = providerOffice[0].Office;
      }
      if (office !== null) {
        if (office.Address1) {
          address = office.Address1;
        }
        if (office.Address2) {
          address += ", " + office.Address2;
        }
        if (office.Address3) {
          address += ", " + office.Address3;
        }
      }
      return address;
    },
    formatProviderTitle(provider) {
      if (provider === undefined) {
        return this.$t("enums.Provider");
      }
      if (provider.ProviderType==='Dental') {
        return this.$t(`enums.${provider.ProviderType}`) + this.$t("Provider");
      }
      return this.$t("enums.Provider");
    },
    formatMember(memberIdentity) {
      if (memberIdentity === undefined) {
        return "";
      }
      return `${memberIdentity.CurrentMember.FirstName} ${memberIdentity.CurrentMember.LastName}`;
    },
    memberAddress(memberIdentity) {
      console.log("ma: ", memberIdentity);
      if (
        memberIdentity &&
        memberIdentity.CurrentContactInformation &&
        memberIdentity.CurrentContactInformation.Address
      ) {
        return this.formatDrawbridgeAddress(
          memberIdentity.CurrentContactInformation.Address
        );
      }
      return "";
    },
    formatDrawbridgeAddress(address) {
      var res = "";
      if (address) {
        if (address.Address1) {
          res += address.Address1 + "\n";
          if (address.Address2) {
            res += address.Address2 + "\n";
            if (address.Address3) {
              res += address.Address3 + "\n";
            }
          }
        } else {
          if (address.SuiteNumber) {
            res += address.SuiteNumber;
          }
          if (address.StreetNumber) {
            if (res.length > 0) {
              res += " ";
            }
            res += address.StreetNumber.toString();
          }
          if (address.StreetName) {
            if (res.length > 0) {
              res += ", ";
            }
            res += address.StreetName;
          }
        }

        if (address.City) {
          if (res.length > 0) {
            res += ", ";
          }
          res += address.City;
        }
        if (address.Country && address.Country.IsOther) {
          if (address.OtherProvince) {
            if (res.length > 0) {
              res += ", ";
            }
            res += address.OtherProvince;
          }
          if (address.OtherPostalCode) {
            res += " " + address.OtherPostalCode;
          }
          if (address.OtherCountry) {
            res += "\n " + address.OtherCountry;
          }
        } else {
          if (address.Province) {
            if (res.length > 0) {
              res += "\n";
            }
            res += address.Province.Code;
          }
          if (address.PostalCode) {
            res += ", " + address.PostalCode;
          }
          if (address.Country) {
            res += ", " + translate(address.Country, this.language.language);
          }
        }
      }
      return res;
    },
    getBankName() {
      console.log("banks json: ", banks);
      let bank = banks.filter(
        (o) => o.InstitutionNumber === this.claim.PaymentInstitutionNumber
      );
      if (bank.length > 0) {
        return bank[0].FinancialInstitutionName;
      }
      return "---";
    },
    matchAddress() {
      if (!this.eobData.ClaimAdmin) return false;
      const htmlString = this.eobData.ClaimAdmin.Address;
      const div = document.createElement("div");
      div.innerHTML = htmlString;
      const plainText = div.textContent || div.innerText || "";
      let header = this.eobData && this.eobData.EOBPlanAddress ? this.eobData.EOBPlanAddress.split(' ').join('').toLowerCase() : "";
      let footer = plainText.split(' ').join('').toLowerCase();
      return header.slice(0, 10) === footer.slice(0, 10);
    }
  },
};
</script>
<style scoped>
.align-right {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.eob-parent {
  break-inside: auto;
}
.eob-child {
  break-inside: avoid;
}
.member-labels {
  font-size: 12px;
  padding: 1px 0;
}
.member-values {
  font-size: 12px;
  font-weight: 600;
}
.table >>> tr:hover {
  background-color: transparent !important;
}
.table >>> td {
  font-size: 0.75rem !important;
  font-weight: 500;
  text-align: left;
  padding-left: 4px !important;
}
.provider-text {
  font-size: 1rem;
  font-weight: 600;
}

.data-text {
  font-size: 0.8rem;
}
.messages-title {
  padding-top: 80px;
  padding-bottom: 5px;
}
.plan-header-text {
  font-size: 1.3rem;
  font-weight: 600;
}
.main-header-text {
  font-size: 1.4rem;
  font-weight: 600;
}
.bold {
  font-weight: 600;
}
.summary-text {
  font-size: 0.875rem;
  font-weight: 500;
  padding-bottom: 0;
  margin: 0 0;
  line-height: 1.1 !important;
}
.date-text {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.1 !important;
}
.address-text {
  font-size: 0.875rem;
  line-height: 1.1 !important;
}
.pdf-content {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  width: 100%;
  background: #fff;
}
.hr-divider {
  border-bottom: 1px solid rgb(163, 163, 163);
  height: 10px;
  color: red;
}
.table >>> th {
  background-color: rgb(236, 236, 236) !important;
  color: black !important;
  font-size: 10px !important;
  height: 24px !important;
  padding: 0 4px !important;
  text-align: left;
  line-height: 1.1;
  font-weight: normal;
}
.table >>> td {
  font-size: 9px !important;
}
.center {
  text-align: center;
  width: 100%;
}
.box {
  border: 2px solid black;
  margin: 10px;
  padding: 10px;
}
.no-wrap {
  white-space: nowrap;
}
pre {
   font-family: "Roboto", Helvetica, Arial, sans-serif;
   font-size: 14px;
}
hr {
  border: none;
  height: 1px;
  background-color: #333;
}
</style>
